import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useShallow } from "zustand/react/shallow";

import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";
import { inputStep, maxInputNumber } from "@/constants/inputs";
import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";
import { getFloat } from "@/utils/mappings";

const desiredLayerCountSchema = z.object({
  desired_layer_count: z.union([
    z.number().lt(maxInputNumber),
    z.string().refine((value) => !isNaN(Number.parseFloat(value)), { message: "Must be a number" }),
  ]),
});

type DesiredLayerCountSchema = z.infer<typeof desiredLayerCountSchema>;
export default function NonCompliantRepair() {
  const { savedAnonCompliantRepairData, setChecks } = useCUCompositeJobStore(
    useShallow((state) => {
      const savedAnonCompliantRepairData = state.sections.checksSection.data;
      return { savedAnonCompliantRepairData, setChecks: state.setChecks };
    })
  );

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<DesiredLayerCountSchema>({
    resolver: zodResolver(desiredLayerCountSchema),
    values: {
      // @ts-expect-error
      desired_layer_count: savedAnonCompliantRepairData.desired_layer_count ?? "",
    },
  });

  const handleSaveDesiredLayerCount = (data: DesiredLayerCountSchema) => {
    setChecks({
      data,
      status: "done",
    });
  };

  return (
    <form onSubmit={handleSubmit(handleSaveDesiredLayerCount)} className="flex flex-col">
      <div className="mb-6 flex flex-wrap items-end gap-2">
        <TextInput
          className="flex-1 basis-full md:basis-56"
          label="Desired Layer Count"
          type="number"
          step={inputStep}
          error={errors.desired_layer_count?.message}
          {...register("desired_layer_count", { setValueAs: getFloat })}
        />
      </div>
      <Button className="self-end" type="submit">
        Save
      </Button>
    </form>
  );
}
